module.exports = __webpack_public_path__ + "40190a96fb78d29e0e8f97c9525d889c.png";